import { render } from "./sclfdzView.vue?vue&type=template&id=3bb77d61"
import script from "./sclfdzView.vue?vue&type=script&lang=js"
export * from "./sclfdzView.vue?vue&type=script&lang=js"

import "./sclfdzView.vue?vue&type=style&index=0&id=3bb77d61&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__